import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, of, throwError } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { StoricoSegnalazioneService } from './storico-segnalazione.service';

@Injectable({
    providedIn: 'root'
  })
export class StoricoSegnalazioneDataSource implements DataSource<ModelEventiCalamitosi.AnaDatiRaccoltiStoricoDTO> {

    segnalazioneStoricoSubject = new BehaviorSubject<ModelEventiCalamitosi.AnaDatiRaccoltiStoricoDTO[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    public loading$ = this.loadingSubject.asObservable();
    private errorSubject = new BehaviorSubject<boolean>(false);
    public errors$ = this.errorSubject.asObservable();
    isLoading: boolean = false;
    errorMessage: string = null;

    private countSubject = new BehaviorSubject<number>(0);
    public counter$ = this.countSubject.asObservable();

    constructor(private storicoSegnalazioniService: StoricoSegnalazioneService) {
    }

    loadStoricoSegnalazione(ipa: string,
      codiceSegnalazione: number,
      sortDirection: string,
      ente: number) {

      this.loadingSubject.next(true);

      this.storicoSegnalazioniService.getList(codiceSegnalazione, sortDirection, ente).pipe(
        catchError(err => {
          this.errorSubject.next(true);
          return throwError(err);
        }),
        catchError(err => {
          return of([]);
        }),
        finalize(() => this.loadingSubject.next(false))
      )
        .subscribe(result => {
          this.segnalazioneStoricoSubject.next(result);
        }
        );
    }

    connect(collectionViewer: CollectionViewer): Observable<ModelEventiCalamitosi.AnaDatiRaccoltiStoricoDTO[]> {
      return this.segnalazioneStoricoSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
      this.segnalazioneStoricoSubject.complete();
      this.loadingSubject.complete();
    }
}
